// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"9b7e3375","278":"9b7e3375","583":"9b7e3375","946":"9b7e3375"}[chunkId] + ".chunk.css";
};